import React from 'react';
import { useHistory } from 'react-router-dom';
import './AccountActivationError.css';

export default function AccountActivationError() {
  const history = useHistory();

  return (
    <div className="account-activation-error-page">
      <div className="account-activation-error-card">
        <div className="account-activation-error-icon" aria-hidden="true">
          ❌
        </div>
        <h1 className="account-activation-error-title">Erreur d'activation</h1>
        <p className="account-activation-error-message">
          Impossible d’activer votre compte. Vérifiez le lien ou contactez le support ❌
        </p>
        <button
          type="button"
          className="account-activation-error-button"
          onClick={() => history.push('/login')}
        >
          Retourner à la connexion
        </button>
      </div>
    </div>
  );
}
